import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MenuItem } from "../types/menu";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menu: MenuItem[] = [
    { name: "Home", link: "/" },
    { name: "Datasets", link: "/datasets" },
    { name: "Privacy", link: "/privacy" },
    { name: "Contact", link: "/contact" },
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="sticky top-0 left-0 w-full z-40 bg-primary text-white py-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center px-6">
        {/* Dark Overlay */}
        <div
          className={`fixed inset-0 top-20 bg-black z-10 transition-opacity duration-500 ease-in-out ${
            isMenuOpen ? "opacity-50" : "opacity-0 pointer-events-none"
          }`}
          onClick={toggleMenu}
        ></div>

        {/* Logo */}
        <div className="text-2xl font-serif">
          <Link to="/" className="hover:text-secondary transition">
            OpenMetaData.net
          </Link>
        </div>

        {/* Hamburger Icon for Mobile */}
        <button
          className="lg:hidden text-2xl focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? "\u2715" : "\u2630"}
        </button>

        {/* Navigation Links */}
        <ul
          className={`lg:flex lg:space-x-6 text-lg font-sans items-center 
          transition-all duration-300 ease-in-out overflow-hidden lg:overflow-visible ${
            isMenuOpen ? "max-h-screen" : "max-h-0"
          }
          lg:block absolute lg:static bg-primary lg:bg-transparent w-full lg:w-auto top-16 left-0 lg:top-auto lg:left-auto shadow-lg lg:shadow-none px-4 lg:p-0 z-10`}
        >
          {menu.map((item, index) => (
            <li key={index} className="my-2 lg:my-0">
              <Link
                to={item.link}
                className="block lg:inline-block hover:text-secondary font-semibold transition px-4 py-2 lg:p-0"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
